import { BenQuery } from './BenQuery'
import { BenArt } from './BenArt'
import { BenForm } from './BenForm'
import App from '@/App.vue'
import { BenVideo } from './BenVideo'
import { BenAnimate } from './BenAnimate'
import { BenSw } from './BenSw'
import { BenHash } from './BenHash'
import { BenSc } from './BenSc'
import { BenImageSlides } from './BenImageSlides'
import { BenGallery } from './BenGallery'
import { BenBbMore } from './BenBbMore'
import { BenSlideDown } from './BenSlideDown'
import { BenView } from './BenView'
import { BenProxyClick } from './BenProxyClick'
import { BenHeader } from './BenHeader'
const _artDones = [] as HTMLElement[]
const _formDones = [] as HTMLElement[]
const _videoDones = [] as HTMLElement[]
const _animateDones = [] as HTMLElement[]
const _swDones = [] as HTMLElement[]
const _scDones = [] as HTMLElement[]
const _imageSlidesDones = [] as HTMLElement[]
const _galleryDones = [] as HTMLElement[]
const _bbMoreDones = [] as HTMLElement[]
const _bbSlideDownDones = [] as HTMLElement[]
const _hrefActiveDones = [] as HTMLElement[]
const _proxyClickDones = [] as HTMLElement[]
const _meDones = [] as HTMLElement[]
const _setHeightDones = [] as HTMLElement[]
export class BenBase {
  static initQueryList(app) {
    BenArt.init(_artDones, app)
    BenForm.init(_formDones, app)
    BenVideo.init(_videoDones)
    BenAnimate.init(_animateDones)
    BenSw.init(_swDones, app)
    BenSc.init(_scDones)
    BenImageSlides.init(_imageSlidesDones, app)
    BenGallery.init(_galleryDones, app)
    BenBbMore.init(_bbMoreDones, app)
    BenSlideDown.init(_bbSlideDownDones)
    BenProxyClick.init(_proxyClickDones)
    _setActiveHrefClass(_hrefActiveDones)
  }
  static init(app: InstanceType<typeof App>) {
    document.addEventListener('DOMContentLoaded', () => {
      BenView.init()
      _initLangShow()
      _initScrollTopBtns()
      _initOutHref()
      BenHash.init()
      BenHeader.init()
      BenBase.initQueryList(app)
    })
  }
}

function _initLangShow() {
  let isActive = false
  const $lang = document.querySelector('.g-header .right > .lang')
  if (!$lang) return
  $lang.addEventListener('click', (e) => {
    e.stopPropagation()
    isActive = !isActive
    $lang.classList.toggle('active', isActive)
  })
  document.addEventListener('click', (e) => {
    isActive = false
    $lang.classList.remove('active')
  })
}

function _setActiveHrefClass(activeHrefDones: Array<any>) {
  const aLinks = document.querySelectorAll('a')
  const pathname = BenQuery.getLocationPathname()
  aLinks.forEach((link) => {
    if (activeHrefDones.includes(link)) return
    activeHrefDones.push(link)
    const href = link.getAttribute('href')
    if (href === pathname) link.classList.add('active')
  })
}

function _initScrollTopBtns() {
  const $btns = Array.from(document.querySelectorAll('.c-scroll-top')) as HTMLElement[]
  const ifShow = () => {
    arr.forEach(($btn) => {
      if (window.scrollY > 500) {
        $btn.classList.add('show')
      } else {
        $btn.classList.remove('show')
      }
    })
  }
  const arr = [] as HTMLElement[]
  let timer = null as any
  ifShow()
  $btns.forEach(($btn) => {
    arr.push($btn)
    $btn.addEventListener('click', (e) => {
      e.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  })
  window.addEventListener('scroll', () => {
    clearTimeout(timer)
    timer = setTimeout(ifShow, 100)
  })
}

function _initOutHref() {
  const $aList = document.querySelectorAll('a')
  $aList.forEach(($a) => {
    $a.addEventListener('click', () => {
      const href = $a.href
      if (href.includes('//wa.me')) {
        BenView.setAction('ow')
      } else if (href.includes('//www.rigardled')) {
        BenView.setAction('oh')
      } else if (href.includes('//www.facebook.com') || href.includes('//www.instagram.com') || href.includes('//www.youtube.com')) {
        BenView.setAction('ov')
      }
    })
  })
}
